import { combineReducers } from "redux";

import modal from "./modal";
import request from "./request";
import dashboard from "./dashboard";
import invoiceList from "./invoiceList";
import invoice from "./invoice";
import createEditStatement from "./createEditStatement";
import agent from "./agent";
import app from "./app";
import prepayment from "./prepayment";

const rootReducer = combineReducers({
  modalStore: modal,
  requestStore: request,
  dashboardStore: dashboard,
  invoiceListStore: invoiceList,
  invoiceStore: invoice,
  createEditStatementStore: createEditStatement,
  agentStore: agent,
  appStore: app,
  prepaymentStore: prepayment
});

export default rootReducer;
